module.exports = __webpack_public_path__ + "static/media/vf_mtshirts_core.22da8c43.svg";